import { connect } from 'react-redux';
import { bindActionCreators, compose } from 'redux';

import { editReimbursable } from '../actions';

import { default as Component } from '../components/ReimbursableListItem';

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        editReimbursable
    }, dispatch);
}

const Container = compose(
    connect(
        null,
        mapDispatchToProps
    )
)(Component);

export default Container;